import { SvgEdit, SvgPlus, SvgUser } from "../icons"
import { MeetingType } from "../../types/meetingTypes"
import { Button } from "../ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu"

type Props = {
  setNewMeetingType: (type: MeetingType) => void
  setShowNewMeeting: (show: boolean) => void
  setKeepBackToButton: (keep: boolean) => void
  setClickReschedule: (click: boolean) => void
}

export function NewMeetingDropdown({
  setNewMeetingType,
  setShowNewMeeting,
  setKeepBackToButton,
  setClickReschedule,
}: Props) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="lg" data-cy="coach-scheduling-new-meeting">
          New Meeting
          <SvgPlus />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56">
        <DropdownMenuGroup>
          <DropdownMenuItem onClick={() => {
            setNewMeetingType("individual")
            setShowNewMeeting(true)
            setKeepBackToButton(true)
            setClickReschedule(false)
          }}>
            <SvgUser className="mr-2" />
            Individual (Billable)
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => {
            setNewMeetingType("custom")
            setShowNewMeeting(true)
            setKeepBackToButton(true)
            setClickReschedule(false)
          }}>
            <SvgEdit className="mr-2" />
            Non-billable
          </DropdownMenuItem>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
